import { Position } from "@blueprintjs/core"
import * as PortalAction from "@src/Actions/PortalActions"
import { usePortalSize } from "@src/Components/Common/usePortalSize"
import ZegPanel from "@src/Components/Common/ZegPanel"
import ThreeDotMenu from "@src/Components/ThreeDotMenu"
import { ContentArea } from "@src/Components/View"
import { SETTINGS_ACTION_COLLAPSE_BREAKPOINT } from "@src/Constants"
import C from "@src/Controller"
import { VIEW_PATHS } from "@src/Routes/constants"
import * as T from "@src/types"
import { Button } from "@zeguro/component-library"
import * as React from "react"
import { useDispatch } from "react-redux"
import { useHistory } from "react-router"

interface ISettingsContainer {
  children: JSX.Element
}

export const settingsTabs = [
  { id: "you", text: "Your Details", shortText: "Your Details" },
  {
    id: "organization",
    text: "Organization Details",
    shortText: "Organization Details",
  },
  {
    id: "admins",
    text: "Manage Cyber Safety Admins",
    shortText: "Manage Admins",
  },
]

const SettingsContainer = ({ children }: ISettingsContainer) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const { clientWidth, isDesktop } = usePortalSize()
  const paths = history.location.pathname.split("/")
  const tabPath = paths[2]

  const navigateToSubscription = () => {
    dispatch(PortalAction.setPortalMenu("subscription"))
    history.push(VIEW_PATHS.subscription)
  }

  const renderHeaderAction = () => {
    if (!isDesktop) {
      return undefined
    }

    if (clientWidth < SETTINGS_ACTION_COLLAPSE_BREAKPOINT) {
      return (
        <ThreeDotMenu
          menuItems={[
            {
              caption: "Manage Subscription",
              action: navigateToSubscription,
            },
          ]}
          position={Position.BOTTOM_RIGHT}
        />
      )
    }

    return (
      <Button
        variant="secondary"
        onClick={navigateToSubscription}
        width="300px"
        padding="6px 16px"
        margin="0 0 10px 28px"
        borderRadius="32px"
        style={{
          letterSpacing: "2%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        Manage Subscription
      </Button>
    )
  }

  React.useEffect(() => {
    C.Portal.getUserList()
    C.Portal.getUserInviteList()
    C.heapTrack("Viewed Settings")
  }, [])

  return (
    <ContentArea>
      <ZegPanel
        tabs={settingsTabs}
        onTabChange={(id) => history.push(`${T.ViewTypes.settings}/${id}`)}
        selectedTabId={tabPath}
        headerAction={renderHeaderAction()}
      >
        {children}
      </ZegPanel>
    </ContentArea>
  )
}

export default SettingsContainer
